<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <div class="content"
             v-if="loading">
            <noResouse v-if="!lists.length"></noResouse>
            <div class="list-wrap"
                 v-else>
                <div class="list-title1"
                     v-if="chapter.title">{{chapter.title|tit}}</div>
                <div class="list list1"
                     v-if="lists.length">
                    <div class="list-word"
                         v-for="(word,index) in lists">{{word.content}}</div>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            titles: "作业预览",
            loading: false,
            taskId: this.$route.params.taskid,
            closeFlag: true,
            lists: [],
            chapter: {},
        }
    },
    created () {
        let that = this;
        this.$http.post(API_URL_TASK_API + '/szyz/check/task/preview', {
            "message_id": this.taskId,
        }).then(res => {
            this.loading = true;
            if (res.data.response == 'ok') {
                this.lists = res.data.data;
            }
        })
    },
    filters: {
        tit: function (title) {
            title = title.split(" ").join("").slice(1);
            return "《 " + title + " 》"
        },
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
    },
    components: {
        headers,
        noResouse,
        loadingS
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    .content {
        .list-wrap {
            background-color: #fff;
            .list-title1 {
                font-size: 36px / $ppr;
                text-align: left;
                color: #333;
                height: 96px / $ppr;
                line-height: 96px / $ppr;
                padding-left: 24px / $ppr;
                font-weight: bold;
                border-bottom: 1px / $ppr solid #e8e8e8;
            }
            .list-con {
                border-bottom: 1px / $ppr solid #e8e8e8;
                div {
                    margin: 24px / $ppr;
                    padding: 24px / $ppr;
                    background-color: #f4f4f4;
                    border-radius: 6px;
                    font-size: 30px / $ppr;
                    color: #333;
                    word-break: break-all;
                    word-wrap: break-word;
                }
            }
            .list {
                background-color: #fff;
                div {
                    border-bottom: 1px / $ppr solid #e8e8e8;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    padding-left: 24px / $ppr;
                    text-align: left;
                    font-size: 30px / $ppr;
                    color: #333;
                }
                .list-tit {
                    font-weight: bold;
                }
                .list-word {
                    color: #555;
                }
            }
            .list2 .list-word:last-child {
                border: 0;
            }
        }
    }
}
</style>
